import React from 'react';
import _ from 'lodash';

import { OrderProduct } from '../../../api-client';
import { BUSINESS_UNIT_TYPES } from '../../../utils/constants/business-unit-types';
import { orderQuantityByProducts } from '../../../utils/data-format-enchanters/order-products-enchanter';

import './bv-order-quantity-details.scss';

interface IBVOrderQuantityDetails {
    orderProducts?: OrderProduct[];
}

const BVOrderQuantityDetails: React.FunctionComponent<IBVOrderQuantityDetails> = ({ orderProducts }) => (
    <div className="bv-order-quantity-details-container">
        <span className="bv-order-quantity-total">
            {`Total Items: ${orderQuantityByProducts(orderProducts)}`}
        </span>
        <span className="bv-order-quantity-partial">
            {`Jewelry: ${orderQuantityByProducts(_.filter(orderProducts, entry => entry.businessUnitCode === BUSINESS_UNIT_TYPES.JEWELRY_CODE))}`}
        </span>
        <span className="bv-order-quantity-partial">
            {`Watches: ${orderQuantityByProducts(_.filter(orderProducts, entry => entry.businessUnitCode === BUSINESS_UNIT_TYPES.WATCH_CODE))}`}
        </span>
    </div>
);

export default BVOrderQuantityDetails;